import { CategoryLandingPageKey } from '@lambda/apis/src/category/types';
import Image from 'next/future/image';
import Link from 'next/link';
import { getEdgeUrl } from '@/lib/getEdgeUrl';
import settings from '@/settings';
import { SubCategoryDataT } from '../types';

const FeaturedArea = ({
  category,
  handle,
  categoryHandle,
  link,
}: {
  category: SubCategoryDataT;
  handle: CategoryLandingPageKey;
  categoryHandle: string;
  link: string;
}) => {
  const imageUrl = getEdgeUrl(
    `images/collections/category/sub-categories/${handle}/${categoryHandle}.jpeg`,
  );

  const categoryDescription =
    category.storeConfig?.[settings.store]?.description ??
    category.config.description;

  const categoryTitle =
    category.storeConfig?.[settings.store]?.title ?? category.config.title;

  return (
    <div className="relative min-h-[300px] w-full rounded-md lg:w-2/5">
      <div className="absolute h-full w-full">
        <Image
          src={imageUrl}
          alt={category.name}
          height={1000}
          width={1000}
          quality={100}
          className="h-full w-full rounded-md object-cover"
          loading="eager"
        />
        <div className="absolute bottom-0 h-full w-full">
          <div
            className="flex h-full w-full items-end rounded-md"
            // eslint-disable-next-line react/forbid-dom-props
            style={{
              background:
                'linear-gradient(0deg, rgba(0,0,0,0.75) 0%, rgba(0,0,0,0.5) 50%, rgba(255,255,255,0) 100%)',
            }}
          >
            <div className="absolute bottom-0 right-0 w-full p-5 text-white xl:p-10">
              <p className="mb-5 font-bold">{categoryDescription}</p>
              <Link href={link}>
                <a className="rounded-md !bg-white px-5 py-2 text-xs font-bold text-gray-700">
                  {categoryDescription ? 'Shop Now' : ` Shop ${categoryTitle}`}
                </a>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FeaturedArea;
